import { relations } from 'drizzle-orm'
import { integer, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'

// Reusable reply texts ("vastauspohjat") reps insert into the inbox reply
// editor and the quick email composer. Placeholders like {etunimi} are
// rendered client-side, see renderReplySnippet in @markku/utils.
export const replySnippets = pgTable(
  'reply_snippets',
  {
    ...getBaseFields(),
    name: text().notNull(),
    // Typed after "/" in the composer to pick the snippet, e.g. "seuranta"
    shortcut: text().notNull(),
    body: text().notNull(),
    // null = shared with the whole team, otherwise visible only to the owner
    ownerUserId: getNullableIdReference(() => users.id),
    usageCount: integer().notNull().default(0),
    lastUsedAt: getTimestampWithTimezone(),
  },
  (table) => getBaseIndexes('reply_snippets', table),
)

export const replySnippetsRelations = relations(replySnippets, ({ one }) => ({
  owner: one(users, {
    fields: [replySnippets.ownerUserId],
    references: [users.id],
  }),
}))
